import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'

export const formatDate = (date: string) => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_date_day_month_year')
}

export const formatDateTime = (date: string) => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_short_with_time')
}
